{
	"title": "Explain by photo",
	"subtitle": "Upload a photo of a chart, formula or problem — get a LaTeX-rendered explanation and follow-up Q&A.",
	"newCta": "New analysis",
	"list": {
		"empty": {
			"title": "No analyses yet",
			"subtitle": "Snap a photo or upload an image — AI will read and explain it.",
			"cta": "Upload image"
		},
		"search": "Search by title…",
		"count": "{count, plural, one {# analysis} other {# analyses}}",
		"errorTitle": "Couldn't load analyses",
		"errorSubtitle": "Check your connection or try again later.",
		"retry": "Retry"
	},
	"filter": {
		"category": "Category",
		"status": "Status",
		"all": "All"
	},
	"category": {
		"problem": "Problem",
		"graph": "Graph",
		"formula": "Formula",
		"handwriting": "Handwriting",
		"diagram": "Diagram",
		"photo": "Photo",
		"other": "Other"
	},
	"status": {
		"queued": "Queued",
		"analyzing": "Analyzing",
		"ready": "Ready",
		"failed": "Failed"
	},
	"upload": {
		"title": "New analysis",
		"subtitle": "Upload or capture an image, optionally crop the area of interest.",
		"step": {
			"source": "Source",
			"crop": "Crop",
			"progress": "Analysis"
		},
		"source": {
			"file": "File",
			"camera": "Camera",
			"gallery": "Gallery",
			"capture": "Take photo",
			"flipCamera": "Flip camera",
			"drop": "Drop an image",
			"dropFile": "Drop a file here or click to choose",
			"or": "or",
			"fromMaterial": "From material"
		},
		"cropHint": "By default the AI analyses the whole image. Zoom and drag it to select the fragment you need.",
		"cropFirst": "Crop the area to analyze first",
		"cropTool": "Crop",
		"resetCrop": "Whole image",
		"zoom": "Zoom",
		"hintLabel": "Hint for AI (optional)",
		"hintPlaceholder": "E.g. \"this is a graph of a function from my calc lecture\"",
		"analyze": "Analyze",
		"back": "Back",
		"cancel": "Cancel",
		"tip": "The clearer the crop — the better the explanation.",
		"uploading": "Uploading image…",
		"queued": "Queued…",
		"analyzing": "AI is analyzing the image…",
		"openAnalysis": "Open analysis",
		"progressHint": "Usually takes 10–20 seconds. You can close this dialog — analysis continues in the background."
	},
	"crop": {
		"zoom": "Zoom",
		"rotate": "Rotate",
		"confirm": "Confirm crop"
	},
	"latex": {
		"copy": "Copy LaTeX",
		"copied": "LaTeX copied"
	},
	"materialPicker": {
		"title": "Pick from material",
		"selectMaterial": "Choose a material (PDF or image)",
		"selectPage": "Choose a page",
		"thumbnailLoading": "Loading thumbnails…",
		"noPdfMaterials": "You don't have PDF materials yet",
		"noMaterials": "You don't have PDF or image materials yet",
		"noFigures": "Page previews not extracted yet. Try later.",
		"kindImage": "image",
		"useImage": "Use this image",
		"page": "P. {page}",
		"continue": "Continue",
		"back": "Back to material"
	},
	"detail": {
		"back": "Back",
		"loading": "Loading analysis…",
		"analyzing": {
			"title": "Analyzing image",
			"subtitle": "Usually takes 10–20 seconds.",
			"steps": {
				"ocr": "Recognizing content",
				"categorize": "Detecting type",
				"explain": "Building explanation"
			}
		},
		"explanation": "Explanation",
		"keyPoints": "Key points",
		"ocrText": "Recognized text",
		"imageSource": "Source image",
		"copyToNote": "Save to note",
		"zoom": {
			"in": "Zoom in",
			"out": "Zoom out",
			"reset": "Reset"
		},
		"errorTitle": "Couldn't load analysis",
		"failedTitle": "Analysis failed",
		"failedSubtitle": "Looks like a temporary AI hiccup. You can retry — the image is already uploaded.",
		"retry": "Retry analysis",
		"retrying": "Restarting…"
	},
	"saveToNote": {
		"success": "Note created",
		"openNote": "Open",
		"error": "Couldn't create note"
	},
	"askTutor": {
		"cta": "Ask the tutor",
		"disclaimer": "Answers are AI-generated and may contain errors. For exams, olympiads, and other complex tasks, it is recommended to double-check the solution.",
		"chips": {
			"simpler": "Explain simpler",
			"deeper": "Explain in more detail",
			"steps": "Break it down step by step"
		},
		"prompts": {
			"simpler": "Explain this problem in simpler terms: \"{subject}\".",
			"simplerNoTitle": "Explain the analysis of this image in simpler terms.",
			"deeper": "Explain this problem in more detail: \"{subject}\".",
			"deeperNoTitle": "Explain the analysis of this image in more detail.",
			"steps": "Break down the solution to this problem step by step: \"{subject}\".",
			"stepsNoTitle": "Break down the solution to the problem in this image step by step."
		}
	},
	"card": {
		"actions": "Actions"
	},
	"delete": {
		"title": "Delete analysis?",
		"subtitle": "The analysis will move to trash for 30 days.",
		"confirm": "Delete",
		"cancel": "Cancel",
		"success": "Analysis deleted"
	},
	"mermaid": {
		"rendering": "Diagram…",
		"error": "Couldn't render the diagram",
		"showSource": "Show source",
		"copy": "Copy source",
		"copied": "Copied",
		"fullscreen": "Open fullscreen",
		"download": "Download PNG",
		"downloadError": "Couldn't download PNG"
	},
	"errors": {
		"heicConversionFailed": "Couldn't convert HEIC. Save the file as JPG and try again.",
		"uploadFailed": "Couldn't upload the image",
		"processingFailed": "Couldn't process the image",
		"unsupportedFormat": "Unsupported format. JPG · PNG · WEBP · HEIC.",
		"fileTooLarge": "File too large. Maximum 10 MB.",
		"noFile": "Pick a file first",
		"deleteFailed": "Couldn't delete",
		"cameraPermissionDenied": "Camera access denied. Allow access in browser or app settings.",
		"cameraNotFound": "No camera found on this device.",
		"cameraFailed": "Couldn't open the camera"
	},
	"intro": {
		"title": "A photo instead of a question",
		"body": "The breakdown follows what is in the shot: a graph gets its axes and trend, a problem gets the steps. Handwriting is recognised too.",
		"bullets": [
			"A page can be taken from a material already uploaded",
			"A camera shot works: HEIC is converted for you",
			"A finished breakdown saves into a note in one action"
		]
	}
}
